












































































































































































































import Vue from 'vue';
import store from '@/store';
import {
  OrgUser,
  PeerGroupMembership,
  UNRULR_MANAGER
} from '@/models/orgStructure';
import { MemberRole, WebRequestStatus } from '@/models';
import * as Utils from '@/utils';

import OrganizationRoleInfo from '@/components/info/OrganizationRoleInfo.vue';
import OrganizationUserGroupMembership from '@/components/OrganizationUserGroupMembership.vue';
import OrganizationUserMembership from '@/components/OrganizationUserMembership.vue';
import OrgRoles from '@/components/roles/OrgRoles.vue';
import PeerGroupRoleInfo from '@/components/info/PeerGroupRoleInfo.vue';
import PersistableItem from '@/components/PersistableItem.vue';
import RoleSwitch from '@/components/RoleSwitch.vue';
import UnrulrFilter from '@/components/Filter.vue';

export default Vue.extend({
  components: {
    OrganizationRoleInfo,
    OrganizationUserGroupMembership,
    OrganizationUserMembership,
    OrgRoles,
    PeerGroupRoleInfo,
    PersistableItem,
    RoleSwitch,
    UnrulrFilter
  },

  props: {
    userId: Number
  },

  data() {
    return {
      isDialogOpen: false,
      peerGroupFilter: '',
      tempStatus: WebRequestStatus.READY
    };
  },

  computed: {
    user(): OrgUser {
      return store.getters.org.user(this.userId);
    },

    userStatus(): WebRequestStatus {
      return store.getters.org.status.user(this.userId);
    },

    initials(): string {
      if (!this.user.name) {
        return this.user.email[0].toUpperCase();
      }

      return this.user.name
        .split(' ')
        .map(nameToken => nameToken[0])
        .join('');
    },

    emails(): string[] {
      return this.user.emails.map(ue => ue.email).sort();
    },

    orgPeerGroupMemberships(): PeerGroupMembership[] {
      return store.state.org.org.peerGroups
        .map(opg => ({
          ...opg,
          role: MemberRole.STUDENT,
          manager: UNRULR_MANAGER
        }))
        .filter(pgm => pgm.isActive);
    },

    newGroupOptions(): [PeerGroupMembership, WebRequestStatus][] {
      const activeIds = this.existingMemberships.reduce(
        (agg, pgm) => agg.add(pgm.peerGroupId),
        new Set<number>()
      );

      return this.orgPeerGroupMemberships
        .filter(opg => !activeIds.has(opg.peerGroupId))
        .sort(Utils.sortNamed)
        .map(pg => [
          pg,
          store.getters.org.status.relationship(this.userId, pg.peerGroupId)
        ]);
    },

    filteredGroupOptions(): [PeerGroupMembership, WebRequestStatus][] {
      return Utils.findTerm(
        this.peerGroupFilter,
        this.newGroupOptions,
        ([membership]) => [
          membership.name,
          membership.section,
          membership.description
        ]
      );
    },

    existingMemberships(): PeerGroupMembership[] {
      return this.user.memberships.slice().sort(Utils.sortNamed);
    },

    memberships(): [PeerGroupMembership, WebRequestStatus][] {
      const separated = [
        ...this.existingMemberships.filter(pgm => pgm.isActive),
        ...this.existingMemberships.filter(pgm => !pgm.isActive)
      ];

      return separated.map(m => [
        m,
        store.getters.org.status.relationship(this.userId, m.peerGroupId)
      ]);
    },

    hideSearchBox(): boolean {
      return this.newGroupOptions.length < 15;
    },

    organizationId(): number {
      return store.state.org.basic.organizationId;
    }
  },

  methods: {
    goToSettings() {
      this.$router.push({
        name: 'OrganizationUserSettings',
        params: {
          organizationId: `${this.organizationId}`,
          memberId: `${this.userId}`
        }
      });
    },

    changeOrgRole(user: OrgUser) {
      store.dispatch.org.updateUserRoles(user);
    },

    changeRole(membership: PeerGroupMembership) {
      store.dispatch.org.updateUserGroupConnection({
        userId: this.user.userId,
        peerGroupId: membership.peerGroupId,
        role: membership.role
      });
    },

    addMembership(membership: PeerGroupMembership) {
      store.dispatch.org.addUserGroupConnection({
        userId: this.user.userId,
        peerGroupId: membership.peerGroupId,
        role: membership.role
      });
    },

    removeMembership(membership: PeerGroupMembership) {
      store.dispatch.org.removeUserGroupConnection({
        userId: this.user.userId,
        peerGroupId: membership.peerGroupId,
        role: membership.role
      });
    },

    updateFilter(filter: string) {
      this.peerGroupFilter = filter;
    }
  }
});
